/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'liubei-1': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備、關羽、張飛', w: 1 },
      { f: 'hj', n: '黃巾', l: '黃巾殘部' },
      { f: 'han', n: '督郵', l: '督郵（郡裡派來的官）' },
    ],
    before: '黃巾起事，劉備帶著關羽、張飛跟隨校尉鄒靖討賊有功，當上中山國安喜縣的縣尉。《典略》（裴注）說，這時朝廷下詔，要淘汰因軍功當官的人，督郵來到縣裡。',
    after: '劉備求見督郵不成，直接闖進去把他綁起來，打了二百杖，再把官印綬帶套在他脖子上，綁在拴馬樁，然後棄官逃走。之後他跟著毌丘毅到丹楊募兵，在下邳遇賊立功，當上下密丞，不久又辭官。',
    src: '《三國志·蜀書·先主傳》；裴注引《典略》',
  },
  'liubei-2': {
    sides: [
      { f: 'han', n: '孔融', l: '太史慈（孔融守北海）', w: 1 },
      { f: 'shu', n: '劉備', l: '精兵三千', w: 1 },
      { f: 'hj', n: '黃巾', l: '管亥' },
    ],
    before: '黃巾管亥圍攻北海，北海相孔融被困在都昌。太史慈因為孔融照顧過他母親，趕來助守，自請突圍去平原向劉備求救。他連著幾天早上出城射靶，等圍兵習慣不再理會，才策馬衝出包圍。',
    after: '劉備說「孔北海知世間有劉備邪」，馬上派精兵三千跟太史慈回去。賊兵聽說援軍到了，解圍散走。',
    src: '《三國志·吳書·太史慈傳》',
  },
  'liubei-3': {
    sides: [
      { f: 'lb', n: '呂布', l: '呂布（曹豹反，開城相迎）', w: 1 },
      { f: 'shu', n: '劉備', l: '劉備、張飛' },
      { f: 'yh', n: '袁術', l: '袁術' },
    ],
    before: '陶謙死後，劉備接掌徐州。建安元年袁術來攻，劉備帶兵到盱眙、淮陰抵擋，相持了一個多月。呂布趁劉備不在，襲取下邳；城裡的守將曹豹反叛，暗中迎接呂布。',
    after: '呂布俘虜了劉備的妻兒，劉備轉軍海西。後來劉備向呂布求和，呂布送還家眷，讓他駐在小沛；等劉備又聚起一萬多人，呂布出兵來攻，劉備敗走投奔曹操。',
    src: '《三國志·蜀書·先主傳》〈呂布傳〉',
  },
  'liubei-4': {
    sides: [
      { f: 'wei', n: '曹操', l: '張遼、關羽', w: 1 },
      { f: 'ys', n: '袁紹', l: '顏良' },
    ],
    before: '建安五年，曹操東征，劉備兵敗投奔袁紹，家眷被俘，關羽也被擒。曹操拜關羽為偏將軍，待他很厚。袁紹派顏良到白馬圍攻東郡太守劉延，曹操讓張遼和關羽當先鋒去救。',
    after: '關羽在萬軍之中刺死顏良、帶首級回來，白馬之圍就此解除，曹操表封他為漢壽亭侯。關羽隨即把曹操給的賞賜全部封存，寫信告辭，回到袁紹軍中的劉備身邊；曹操說「彼各為其主」，不准部下追趕。',
    src: '《三國志·蜀書·關羽傳》〈先主傳〉',
  },
  'liubei-5': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備（屯新野）、關羽、張飛' },
      { f: 'han', n: '諸葛亮', l: '諸葛亮（躬耕隆中）' },
    ],
    before: '劉備依附劉表，在新野駐紮多年。《九州春秋》（裴注）說他看見自己大腿長出贅肉，感嘆「老將至矣，而功業不建」。徐庶推薦諸葛亮，說這個人只能親自去見，不能叫他來。',
    after: '劉備去了三次才見到諸葛亮，聽了「隆中對」，請他出山。兩人的交情一天比一天好，關羽、張飛不高興，劉備說「孤之有孔明，猶魚之有水也」。',
    src: '《三國志·蜀書·諸葛亮傳》；裴注引《九州春秋》',
  },
  'liubei-6': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹純（虎豹騎）、文聘', w: 1 },
      { f: 'shu', n: '劉備', l: '趙雲、張飛' },
    ],
    before: '劉表病死，兒子劉琮投降曹操。劉備帶著投奔他的十幾萬百姓、幾千輛輜重往江陵撤，一天只走十幾里。曹操挑精騎五千，一日一夜跑三百多里，在當陽長坂追上。',
    after: '劉備丟下妻兒，只帶諸葛亮、張飛、趙雲等數十騎逃走，人眾輜重大多被曹軍奪去。趙雲抱著阿斗、護著甘夫人脫險；張飛帶二十騎據水斷橋，曹兵不敢靠近。劉備往漢津與關羽的船會合，再和劉琦一起到夏口。',
    src: '《三國志·蜀書·先主傳》〈趙雲傳〉〈張飛傳〉；《魏書·曹純傳》',
  },
  'liubei-7': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備、諸葛亮、關羽', w: 1 },
      { f: 'wu', n: '孫權', l: '周瑜、程普', w: 1 },
      { f: 'wei', n: '曹操', l: '曹操' },
    ],
    before: '長坂之後劉備退到夏口，曹操佔了江陵，準備順江東下。諸葛亮說「事急矣」，自請出使柴桑，勸孫權與劉備聯手抗曹。孫權派周瑜、程普帶水軍數萬，和劉備合力。',
    after: '聯軍在赤壁大破曹軍、燒掉船隻，劉備與吳軍水陸並進追到南郡；曹軍又遇疫病，死了很多，曹操引兵北歸。劉備接著南征武陵、長沙、桂陽、零陵四郡，太守都投降；劉琦病死後，眾人推劉備為荊州牧，治所在公安。',
    src: '《三國志·蜀書·先主傳》〈諸葛亮傳〉；《吳書·周瑜傳》',
  },
  'liubei-8': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備、龐統', w: 1 },
      { f: 'lz', n: '劉璋', l: '劉循、劉璝、張任' },
    ],
    before: '建安十六年，劉璋請劉備入蜀對付張魯。後來兩人翻臉，劉備從葭萌回師南下，在涪擊敗劉璝、張任等人，進圍雒城。劉璋的兒子劉循守城，被攻了將近一年。',
    after: '龐統帶兵攻城時中流矢身亡，年僅三十六，劉備一提到他就流淚。建安十九年夏雒城破，劉備進圍成都幾十天，劉璋出降。《益部耆舊雜記》（裴注）說張任在雁橋兵敗被擒，不肯投降而死。',
    src: '《三國志·蜀書·先主傳》〈龐統傳〉；〈劉二牧傳〉；裴注引《益部耆舊雜記》',
  },
  'liubei-9': {
    sides: [
      { f: 'shu', n: '劉備', l: '黃忠、法正', w: 1 },
      { f: 'wei', n: '曹操', l: '夏侯淵、張郃' },
    ],
    before: '劉備進兵漢中，和夏侯淵相持。建安二十四年正月，劉備夜裡燒了魏軍營外的鹿角；夏侯淵讓張郃守東邊，自己帶輕兵守南邊，又分出一半兵力去幫張郃。法正在山上看準時機，說「可擊矣」。',
    after: '黃忠從高處擂鼓吶喊衝下，一戰斬了夏侯淵，魏軍大敗，黃忠升為征西將軍。曹操親自從長安趕來，劉備據險不戰；五月曹操撤軍，劉備取得漢中，秋天自稱漢中王。',
    src: '《三國志·蜀書·法正傳》〈黃忠傳〉〈先主傳〉；《魏書·夏侯淵傳》',
  },
  'liubei-10': {
    sides: [
      { f: 'shu', n: '劉備', l: '趙雲、黃忠、張翼', w: 1 },
      { f: 'wei', n: '曹操', l: '曹操大軍' },
    ],
    before: '夏侯淵死後曹操親來爭漢中，在北山下囤了大批軍糧。據《雲別傳》（裴注），黃忠去搶糧，過了約定時間沒回來，趙雲帶數十騎出營接應，撞上曹軍大隊，一邊打一邊退回營裡。',
    after: '趙雲大開營門、偃旗息鼓，曹軍怕有埋伏退走；趙雲隨即擂鼓、用弩從後面追射，曹軍自相踐踏，很多人掉進漢水淹死。劉備第二天來看，說「子龍一身都是膽也」，軍中稱趙雲為「虎威將軍」。',
    src: '《三國志·蜀書·趙雲傳》裴注引《雲別傳》',
  },
  'liubei-11': {
    sides: [
      { f: 'wu', n: '孫權', l: '陸遜', w: 1 },
      { f: 'shu', n: '劉備', l: '劉備、馮習、張南' },
    ],
    before: '孫權偷襲荊州、殺了關羽。劉備稱帝後親自伐吳，章武二年從巫峽、建平到夷陵一帶連營數十座。陸遜堅守不出，等蜀軍疲憊，才下令每人拿一把茅草，用火攻打蜀營。',
    after: '陸遜在猇亭大破蜀軍，連破四十多座營，馮習、張南戰死；劉備連夜逃回，改走陸路到魚復，改名永安。章武三年四月劉備在永安宮病逝，年六十三；臨終把兒子託付給諸葛亮，說「如其不才，君可自取」。',
    src: '《三國志·蜀書·先主傳》〈諸葛亮傳〉；《吳書·陸遜傳》',
  },
};
